<template>
  <div class="square-containter">
    <div class="con">
      <breadcrumb :list="breadcrumblist"></breadcrumb>
      <div class="detail-con">
        <div class="title_search_box">
          <div class="title">新品采购广场</div>
          <div class="search-box">
            <div class="search-input">
              <img src="../../../assets/images/icon_search.png" alt="" />
              <input
                type="text"
                placeholder="输入商品名称进行查找"
                v-model.trim="keyword"
              />
            </div>
            <div class="search-btn" @click="search">查找商品</div>
          </div>
        </div>
        <div class="goods-list">
          <ul class="goods-header">
            <li class="li1">图片</li>
            <li class="li2">商品名称</li>
            <li class="li3">规格</li>
            <li class="li4">生产厂家</li>
            <li class="li5">批准文号</li>
            <li class="li6">采购数量</li>
            <li class="li7">操作</li>
          </ul>
          <div class="goods-box" v-if="shoppingList.length && loaded">
            <div
              class="goods-item"
              v-for="(item, index) in shoppingList"
              :key="item.id"
            >
              <div class="img-box">
                <el-image
                  class="img"
                  :src="item.image"
                  :preview-src-list="item.largeImageList"
                >
                </el-image>
              </div>
              <div class="goods-name" :title="item.name">
                {{ item.name }}
              </div>
              <div class="goods-gg">
                {{ item.specification }}
              </div>
              <div class="goods-manufacturer">
                {{ item.manufacturer }}
              </div>
              <div class="sn">
                {{ item.approvalNumber }}
              </div>
              <div class="num">
                <input-number
                  :num="item.number"
                  ref="inputNumber"
                  @eventClick="changeSelectNum(1, item, index)"
                  :key="item.id"
                ></input-number>
              </div>
              <div class="btn">
                <span
                  class="span1"
                  v-if="!item.isSelected"
                  @click="addList(item, index)"
                >
                  加入采购单</span
                >
                <span class="span2" v-else @click="cancel(1, item)">
                  移除采购单</span
                >
              </div>
            </div>
          </div>
          <div v-if="!shoppingList.length && loaded" class="empty">
            <div class="empty-img">
              <img :src="require('@/assets/images/sousuo.png')" alt="" />
            </div>
            <div class="empty-con">
              <p class="p1">抱歉，没有找到“{{ storekeyword }}”相关的新品</p>
              <p class="p1">看看输入的文字是否有误</p>
            </div>
          </div>
        </div>
        <div
          class="bottom"
          :class="isfixed ? 'fixed' : 'relative'"
          ref="bottom"
        >
          <div class="l">
            <span class="span4">共{{ totals }}个商品</span>
            <span v-if="shoppingList.length">
              <span class="span3">{{ pageNumber }}</span> / {{ pager }}</span
            >
            <div class="btn-box" v-if="shoppingList.length">
              <div data-v-5c323218="" class="pre c-pointer" @click="prePage">
                <i data-v-5c323218="" class="el-icon-arrow-left"></i>
              </div>
              <div data-v-5c323218="" class="next c-pointer" @click="nextPage">
                <i data-v-5c323218="" class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
          <div class="r">
            <div class="r-img-box" @click="openDialog">
              <img src="../../../assets/images/icon_cgdjd.png" alt="" />
              <span class="count" v-if="this.selectedList.length > 0">{{
                this.selectedList.length
              }}</span>
            </div>
            <div class="total">
              采购登记单共有<span class="span3">{{
                this.selectedList.length
              }}</span
              >个产品
            </div>
            <div
              class="submit-btn"
              @click="submit"
              :class="selectedList.length ? '' : 'notSubmit'"
            >
              点击提交
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="采购登记单"
      :visible.sync="dialogVisible"
      width="1200px"
      class="dialog"
    >
      <div class="goods-box goods-dialog">
        <div class="goods-item" v-for="(item, index) in selectedList">
          <div class="img-box">
            <img v-lazy="item.image" alt="" />
          </div>
          <div class="goods-name">
            {{ item.name }}
          </div>
          <div class="goods-gg">
            {{ item.specification }}
          </div>
          <div class="goods-manufacturer">
            {{ item.manufacturer }}
          </div>
          <div class="sn">
            {{ item.approvalNumber }}
          </div>
          <div class="num">
            <input-number
              :num="item.number"
              ref="selectInput"
              @eventClick="changeSelectNum(2, item, index)"
              :key="item.id"
            ></input-number>
          </div>
          <div class="btn">
            <span class="span2" @click="cancel(2, index)"> 移除采购单</span>
          </div>
        </div>
      </div>
      <div class="bottom-dialog">
        <div class="l">
          采购登记单共有<span>{{ this.selectedList.length }}</span
          >个产品
        </div>
        <div class="submit-btn" @click="submit">点击提交</div>
      </div>
    </el-dialog>
    <alert ref="alert"></alert>
    <success v-if="successShow">{{ message }}</success>
    <toast ref="toast"></toast>
  </div>
</template>

<script>
import alert from "@/components/plugins/alert";
import inputNumber from "../../../components/input-number";
import { mapState, mapMutations } from "vuex";

export default {
  components: { inputNumber, alert },
  data() {
    return {
      breadcrumblist: [
        { name: "首页", path: "/" },
        { name: "新品采购广场", path: "/shoppingsquare" },
      ],
      keyword: "",
      loaded: false,
      pageNumber: 1,
      pageSize: 20,
      source: 1,
      totals: "",
      pager: "",
      shoppingList: [], //商品列表
      dialogVisible: false, //弹框显示
      selectedList: [], //采购列表
      message: "",
      isfixed: false,
      successShow: false,
    };
  },
  computed: {
    ...mapState(["storekeyword", "hasLogin"]),
  },
  methods: {
    ...mapMutations(["CGKEYWORD"]),
    getlist() {
      this.$api
        .GET_GOODSEXTERNALLIST({
          keyword: this.keyword,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          source: this.source,
        })
        .then((res) => {
          this.shoppingList = res.data;
          this.shoppingList.map((item, index) => {
            item.number = 1;
            item.isSelected = false;
            this.selectedList.map((itemdata) => {
              if (item.id == itemdata.id) {
                this.shoppingList.splice(index, 1, itemdata);
              }
            });
          });

          this.totals = res.totals;
          this.pager = res.pager;
          this.loaded = true;
          this.init();
        });
    },
    prePage() {
      if (this.pageNumber > 1) {
        this.pageNumber--;
        this.getlist();
      }
    },
    nextPage() {
      if (this.pageNumber < this.pager) {
        this.pageNumber++;
        this.getlist();
      }
    },
    search() {
      this.pageNumber = 1;
      this.getlist();
      this.CGKEYWORD(this.keyword);
    },
    addList(item, index) {
      let num = this.$refs.inputNumber[index].number;
      this.shoppingList.map((itemdata) => {
        if (itemdata.id == item.id) {
          itemdata.number = num;
          itemdata.isSelected = true;
          if (itemdata.isSelected) {
            this.selectedList.push(itemdata);
          }
        }
      });
    },
    submit() {
      if (!this.hasLogin) {
        this.$router.push({ name: "login" });
      } else if (!this.selectedList.length) {
        return;
      } else {
        let params = [];
        this.selectedList.map((item) => {
          let data = {};
          data.goodsExternalId = item.id;
          data.quantiy = item.number;
          params.push(data);
        });
        this.$api.POST_GOODSEXTERNALRECORD(params).then((res) => {
          console.log(res);
          if (res.status) {
            this.selectedList = [];
            this.getlist();
            this.$refs.alert.message =
              " 采购意向产品不做为真实订单提交。您提交的采购意向产品我们会尽快为您补货。感谢您的提交！";
            this.$refs.alert.show = true;
            this.dialogVisible = false;
          } else {
            this.$refs.toast.info = {
              title: res.message,
              type: "fail",
            };
            this.$refs.toast.isShow();
          }
        });
      }
    },

    cancel(num, data) {
      if (num == 1) {
        this.shoppingList.map((itemdata) => {
          if (itemdata.id == data.id) {
            itemdata.number = 1;
            itemdata.isSelected = false;
            this.selectedList.map((item, index) => {
              if (itemdata.id == item.id) {
                this.selectedList.splice(index, 1);
              }
            });
          }
        });
      } else if (num == 2) {
        this.selectedList.splice(data, 1);
        this.getlist();
        if (!this.selectedList.length) {
          this.dialogVisible = false;
        }
      }
    },
    changeSelectNum(type, item, index) {
      if (type == 1) {
        if (item.isSelected) {
          let num = this.$refs.inputNumber[index].number;
          this.selectedList.map((itemdata, index) => {
            if (item.id == itemdata.id) {
              this.selectedList[index].number = num;
            }
          });
        }
      } else if (type == 2) {
        let num = this.$refs.selectInput[index].number;
        this.selectedList.map((itemdata, index) => {
          if (item.id == itemdata.id) {
            this.selectedList[index].number = num;
          }
        });
      }
    },
    handleScroll(e) {
      // console.log(e, "=====handleScroll=====");
      if (!e.target.documentElement) return;
      let scrollTop =
        e.target.documentElement.scrollTop || e.target.body.scrollTop;
      let scrollHeight =
        e.target.documentElement.scrollHeight || e.target.body.scrollHeight;
      let screeHeight = Number(document.body.clientHeight);

      scrollHeight = scrollHeight - 36;
      // console.log(scrollTop, scrollHeight, screeHeight);
      this.$nextTick(() => {
        if (this.$refs.bottom.style.position == "relative") {
          scrollHeight = scrollHeight - 120;
        }

        if (scrollHeight - scrollTop > screeHeight) {
          this.$refs.bottom.style = "position:fixed";
          // this.$refs.bottom.style = " box-shadow: 0 0px 19px -6px #fcd8d8"
        }

        if (scrollHeight - scrollTop <= screeHeight) {
          this.$refs.bottom.style = "position:relative";
          // this.$refs.bottom.style = " box-shadow: none"

          //  this.$refs.bottom.style.marginBottom = 20 + "px";
        }
      });
    },
    init() {
      this.$nextTick(() => {
        let scrollHeight = document.documentElement.scrollHeight;
        scrollHeight = scrollHeight - 110;
        let screeHeight = document.body.clientHeight;
        // console.log(scrollHeight, screeHeight);

        if (scrollHeight > screeHeight) {
          this.isfixed = true;
        } else {
          this.isfixed = false;
        }
      });
    },
    openDialog() {
      if (this.selectedList.length) {
        this.dialogVisible = true;
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll, true);
  },
  created() {
    this.getlist();
  },
};
</script>

<style lang='scss' scoped>
.square-containter {
  background-color: #fafafa;
  overflow: hidden;
  width: 100%;
  .detail-con {
    background-color: #ffffff;
    border-radius: 12px;
    margin-bottom: 20px;
  }
}

.title_search_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px 20px;
  .title {
    font-size: 28px;
    color: #333333;
  }
  .search-box {
    display: flex;
    height: 38px;
    border-radius: 3px;
    overflow: hidden;
    .search-input {
      width: 280px;
      display: flex;
      align-items: center;
      border: 1px solid #f0f0f0;
      img {
        margin: 0 8px 0 12px;
      }
      input {
        width: 230px;
        height: 100%;
      }
      input::-webkit-input-placeholder {
        color: #b2b2b2;
        font-size: 13px;
      }
    }
    .search-btn {
      @include btn(88px, 38px, rgb(250, 75, 75), #fff, 13px, 0);
    }
  }
}
.goods-list {
  padding: 0 20px;
  .goods-header {
    height: 48px;
    background-color: #fafafa;
    display: flex;
    font-size: 13px;
    color: #808080;
    margin-bottom: 10px;
    li {
      @include flex-c;
    }
  }
}
.li1,
.img-box {
  width: 120px;
}
.li2,
.goods-name {
  width: 260px;
}
.li3,
.goods-gg {
  width: 140px;
}
.li4,
.goods-manufacturer {
  width: 260px;
}
.li5,
.sn {
  width: 190px;
}
.li6,
.num {
  width: 160px;
}
.li7,
.btn {
  width: 140px;
  .span1 {
    display: inline-block;
    @include btn(112px, 36px, rgb(250, 75, 75), #fff, 13px, 3px);
  }
  .span2 {
    display: inline-block;
    border: 1px solid rgb(250, 75, 75) !important;
    @include btn(112px, 36px, #fff, rgb(250, 75, 75), 13px, 3px);
  }
}
.goods-box {
  .goods-item {
    height: 76px;
    display: flex;
    align-items: center;
    border: 1px solid #f5f5f5;
    font-size: 14px;
    color: #505050;
    border-radius: 4px;
    margin-bottom: 6px;
    .img-box {
      .img,
      img {
        width: 60px;
        height: 60px;
        border: 1px solid #f2f2f2;
      }
    }
    .img-box,
    .num,
    .btn {
      @include flex-c;
    }
    .goods-name {
      @include textLineClamp(2);
      // text-align: center;
      padding: 0 20px;
    }
  }
}
.bottom {
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  position: relative;
  border-top: 1px solid #f5f5f5;
  bottom: 0;
  background: #fff;
  width: 1200px;
  z-index: 100;
}
.fixed {
  height: 90px;
  position: fixed;
  bottom: 0;
  background: #fff;
  width: 1200px;
  z-index: 100;
  // box-shadow: 0 0px 19px -6px #fcd8d8;
}
.relative {
  position: relative !important;
}
.l {
  display: flex;
  align-items: center;

  span {
    font-size: 14px;
    color: #808080;
  }
  .btn-box {
    display: flex;
  }
  .span4 {
    margin-right: 14px;
  }
}
.span3 {
  color: #fa4b4b !important;
  font-weight: bold;
}
.l .pre,
.l .next {
  width: 28px;
  height: 28px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d3d3d3;
  margin-left: 14px;
  border-radius: 3px;
  i {
    color: #c8c8c8;
  }
}
.r {
  display: flex;
  align-items: center;

  .r-img-box {
    position: relative;
    cursor: pointer;
    .count {
      position: absolute;
      height: 17px;
      border-radius: 9px;
      font-weight: bold;
      color: #ffffff;
      right: 6px;
      top: 8px;
      font-size: 12px;
      background: #fa4b4b;
      line-height: 17px;
      padding: 0 4px;
      transform: translate(50%, -50%);
    }
  }
  .total {
    margin: 0 22px 0 12px;
  }
  .submit-btn {
    font-weight: bold;
    @include btn(150px, 52px, rgb(250, 75, 75), #fff, 17px, 3px);
  }
}
.empty {
  height: 198px;
  width: 900px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fcfcfc;
  margin: 50px auto 200px;
  .empty-img {
    // margin: 56px 36px 0 192px;
    margin-right: 30px;
  }
  .empty-con {
    // margin-top: 70px;
    .p1 {
      font-size: 15px;
      color: #666666;
      line-height: 20px;
    }
  }
}
/deep/ .el-dialog {
  border-radius: 14px;
  height: 670px;
  overflow: hidden;
}
/deep/ .el-dialog__title {
  font-size: 24px;
  color: #333333;
}
/deep/ .el-dialog__body {
  padding: 30px 0;
}
.goods-dialog {
  height: 500px;
  overflow: auto;
  padding: 0 20px;
}
.bottom-dialog {
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 0px 19px -6px #fcd8d8;
  .l {
    span {
      color: #fa4b4b;
      font-weight: bold;
    }
  }
  .submit-btn {
    font-weight: bold;
    @include btn(150px, 52px, rgb(250, 75, 75), #fff, 17px, 3px);
  }
}
.notSubmit {
  opacity: 0.6;
}
/deep/ .el-image-viewer__next {
  right: calc(50% - 400px);
  color: #fa4b4b !important;
  background: #fff !important;
}
/deep/ .el-image-viewer__prev {
  left: calc(50% - 400px);
  color: #fa4b4b !important;
  background: #fff !important;
}
/deep/ .el-image-viewer__close {
  right: calc(50% - 500px);
  top: 80px;
  background: #fff !important;
  i {
    color: #fa4b4b !important;
  }
}
/deep/ .el-image-viewer__actions {
  background: #fff !important;
}
/deep/ .el-image-viewer__actions__inner {
  color: #fa4b4b !important;
}
// /deep/ [class^=el-icon-]{
//   color: #fa4b4b;
// }
</style>


// WEBPACK FOOTER //
// src/pages/main/shoppingsquare/index.vue